import { Skeleton } from '@mui/material'
import { styled } from '@mui/material/styles'
import { FC } from 'react'
import { theme } from '../../../../modules/App/Providers/Theme/theme'

type GridArea = 'configuration' | 'day' | 'time' | 'ctas'

const SectionSkeleton = ({ gridArea }: { gridArea: GridArea }) => (
  <div style={{ gridArea }}>
    <Skeleton width="100%" height="3rem" />
    <Skeleton variant="rectangular" width="100%" height={400} />
  </div>
)

const Container = styled('div')<{
  isCondensed?: boolean
}>`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${({ isCondensed }) => (isCondensed ? '0.25rem' : '1rem')};
  grid-template-areas:
    'configuration .    day  .    time'
    'ctas          ctas ctas ctas ctas';
  grid-template-columns: 1fr auto 1fr auto 1fr;
  grid-template-rows: auto;
  justify-content: center;

  @media (min-width: 769px) {
    align-items: start;
    flex-direction: row;
    gap: 1rem;
    grid-template-areas:
      'configuration .    day  .    time'
      'ctas          ctas ctas ctas ctas';
    grid-template-columns: 1fr auto 1fr auto 1fr;
    grid-template-rows: auto auto;
  }
`

const VerticalRule = styled('div')`
  align-content: start;
  background-color: ${theme.palette.grey[200]};
  display: none;
  align-self: end;
  height: 1px;

  @media (min-width: 769px) {
    display: grid;
    height: 96%;
    place-items: center;
    width: 1px;
  }
`
const Gap = styled('div')`
  height: 1rem;
  width: 100%;

  @media (min-width: 769px) {
    display: none;
  }
`

const Wrapper = styled('div')`
  max-width: 30rem;
  justify-self: center;
  width: 100%;
`

interface SectionProps {
  gridArea: GridArea
  style?: any
}

const Section: FC<SectionProps> = ({ children, gridArea, style }) => <Wrapper style={{ gridArea, ...style }}>{children}</Wrapper>

export type { GridArea }
export { Container, Gap, Section, SectionSkeleton, VerticalRule }
